<template>
  <div :class="`metapic-input metapic-input-flex`" :style="`width: ${(col / 12) * 100}%;`">
    <div class="metapic-input-label">{{ label }}</div>
    <el-select :model-value="data" size="large" :placeholder="placeholder" :teleported="false" @change="updateData">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      required: true,
    },
    options: {
      required: true,
      type: Array,
    },
    placeholder: {
      required: false,
      default: '',
      type: String,
    },
    type: {
      default: 'text',
      required: false,
    },
    col: {
      type: [Number, String],
      default: 12,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      data: this.modelValue,
    }
  },
  methods: {
    updateData(newValue) {
      this.data = newValue
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
<style scoped lang="scss">
:deep(.el-select) {
  .el-select__wrapper {
    height: 50px;
    border-radius: 4px;
  }

  .el-select__placeholder {
    top: 10px;
    left: -4px;
    font-weight: bold;

    &.is-transparent {
      color: rgb(96, 98, 102);
    }
  }

  .el-select__input {
    padding: 0;
    outline: none;
    width: 0 !important;
    height: 0 !important;
  }

  .el-select__popper {
    margin-top: 0 !important;
  }

}

.el-input .el-input__inner {
  line-height: 20px;
  font-size: 16px;
  padding: 0 12px;
  padding-top: 28px;
  padding-bottom: 8px;
  height: 56px;
}

.metapic-input {
  position: relative;
}
.metapic-input-label {
  position: absolute;
  top: 8px;
  left: 12px;
  z-index: 12;
  font-size: 14px;
  line-height: 18px;
}
.metapic-input-flex {
  float: left;
  padding-right: 16px;
  margin-bottom: 20px;
}
</style>